import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

class Tooltip extends React.PureComponent {
  constructor(props) {
    super(props);

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    const { hideAction } = this.props;

    if (hideAction) {
      document.addEventListener('mousedown', this.handleClick);
    }
  }

  componentWillUnmount() {
    const { hideAction } = this.props;

    if (hideAction) {
      document.removeEventListener('mousedown', this.handleClick);
    }
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClick(ev) {
    const { hideAction } = this.props;

    if (this.wrapperRef && !this.wrapperRef.contains(ev.target)) {
      hideAction();
    }
  }

  render() {
    const { shown, width, content, animated, children, className } = this.props;

    return shown ? (
      <StyledRoot ref={this.setWrapperRef}>
        <StyledTooltip animated={animated} width={width} className={className}>
          {children || content}
        </StyledTooltip>
      </StyledRoot>
    ) : null;
  }
}

Tooltip.propTypes = {
  shown: PropTypes.bool,
  width: PropTypes.number,
  animated: PropTypes.bool,
  children: PropTypes.node,
  content: PropTypes.string,
  hideAction: PropTypes.func,
  className: PropTypes.string,
};

Tooltip.defaultProps = {
  width: 250,
  shown: false,
  content: null,
  children: null,
  animated: false,
  className: '',
  hideAction: () => null,
};

const StyledRoot = styled.div`
  height: 0;
  z-index: 9;
  width: 100%;
  position: relative;
`;

const StyledTooltip = styled.div`
  left: 50%;
  bottom: 30px;
  color: black;
  padding: 10px;
  text-align: left;
  background: white;
  position: absolute;
  border-radius: 10px;
  border: 1px solid #00000017;
  box-shadow: 0 0 9px -2px rgba(0, 0, 0, 0.2);

  :before,
  :after {
    width: 0;
    height: 0;
    content: '';
    position: absolute;
  }

  :before {
    bottom: -10px;
    left: calc(50% - 10px);
    border-top: 10px solid #e8e8e8;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
  }

  :after {
    bottom: -9px;
    left: calc(50% - 9px);
    border-top: 9px solid #fff;
    border-left: 9px solid transparent;
    border-right: 9px solid transparent;
  }

  ${p =>
    p.width &&
    `
    width: ${p.width}px;
    margin-left: calc(-${p.width}px/2);
  `}

  ${p =>
    p.animated &&
    `
    animation: slide .2s ease-in-out;
  `}

  @keyframes slide {
    from {
      opacity: 0;
      margin-top: 50px;
    }
  }
`;

export default Tooltip;
